<div class="col-md-6 col-md-offset-3">
    <h2>Login</h2>
    <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group" >
            <label for="username">Username</label>
            <input type="text" formControlName="username" required>
      <div >
        <!--loginForm.get('username').touched && loginForm.get('username').invalid-->
        @if (loginForm.get('username')?.invalid && loginForm.get('username')?.touched) {
        <div >
          Username is required.
        </div>
      }
      </div>
        
        </div>
        <div class="form-group" >
            <label for="password">Password</label>
  <input type="password" formControlName="password" required>
      <div >
               @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
        <div >
          Password is required.
        </div>
      }
      </div>

        </div>
        <div class="form-group">
                     <!--<button [disabled]="loading" class="btn btn-primary">Login</button>-->
            <button  class="btn btn-primary">Login</button>
            <img  />
            <!--<a [routerLink]="['/register']" class="btn btn-link">Register</a>-->
        </div>
    </form>
</div>

